import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import OLImageLayer from 'ol/layer/Image';
import Static from 'ol/source/ImageStatic';

const ImageLayer = ({
  urlPath,
  extent = [],
  zIndex = 0,
  isMap2 = false,
  isComparison = false,
}) => {
  const map = useSelector((state) =>
    isComparison
      ? isMap2
        ? state.gis.icMap2
        : state.gis.icMap1
      : state.gis.map
  );

  useEffect(() => {
    if (!map) return;

    let finalExtent = extent;
    if (!finalExtent || finalExtent.length === 0) {
      map.getLayers().forEach(function (el) {
        if (el.get('name') === 'farmLayer') {
          finalExtent = el.getSource().getExtent();
        }
      });
    }

    map.getLayers().forEach(function (el) {
      if (el.get('name') === 'imageLayer') {
        map.removeLayer(el);
      }
    });

    if (!urlPath || !finalExtent || finalExtent.length === 0) return;

    let imageLayer = new OLImageLayer({
      source: new Static({
        url: urlPath,
        imageExtent: finalExtent,
        projection: 'EPSG:4326',
        // ! TODO UNCOMMENT THIS LINE
        // crossOrigin: "anonymous",
      }),
    });
    imageLayer.set('name', 'imageLayer');
    map.addLayer(imageLayer);
    imageLayer.setZIndex(zIndex);

    return () => {
      if (map) {
        map.removeLayer(imageLayer);
      }
    };
  }, [map, urlPath, extent, zIndex]);

  return null;
};

export default ImageLayer;
